import { getDistributor } from "app/services/distributorService";

import React, { Component } from "react";
import AsyncSelect from "react-select/async";

class DistributorAutoComplete extends Component {
  constructor() {
    super();
    this.state = {
      selectedValue: 3054,
      searchText: "test",
    };
  }
  customStyles = {
    control: (base) => ({
      ...base,
      height: 34,
      minHeight: 34,
      //width: 250,
    }),
  };
  // handle input change event
  handleInputChange = (value) => {
    this.setState({ searchText: value });
  };

  handleChange = (value) => {
    this.setState({ selectedValue: value });
    this.props.setFieldValue("memberId", value.id);
    this.props.handleChangeOptions(value.id);
  };
  refreshFilter = () => {
    this.props.refreshFilter();
  };
  // load options using API call
  loadOptions = async (value) => {
    const { data } = await getDistributor(value);
    const memberData = [];
    if (data?.data?.length > 0) {
      data.data.map((item) =>
        memberData.push({
          id: item.memId,
          label: `${item.uniqueIdentity} - ${item.company}`,
        })
      );
      const distributor = data.data.filter((item) => {
        // ;
        return item.memId == this.props.value;
      });

      if (distributor.length > 0) {
        const selectedValue = {
          id: distributor[0].memId,
          label: `${distributor[0].uniqueIdentity} - ${distributor[0].company}`,
        };
        this.setState({
          selectedValue,
        });
      }
    }
    return memberData;
  };

  render() {
    return (
      <AsyncSelect
        cacheOptions
        defaultOptions
        value={this.state.selectedValue}
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.id}
        loadOptions={this.loadOptions}
        onInputChange={this.handleInputChange}
        onChange={this.handleChange}
        name="memberId"
        styles={this.customStyles}
      />
    );
  }
}
export default DistributorAutoComplete;
